import React, {useEffect} from "react";
import * as ReactDOMClient from 'react-dom/client';
import { 
    BrowserRouter, 
    HashRouter as Router,
    Route 
} from 'react-router-dom';

import App from "./src/App";
import { SnackbarProvider, enqueueSnackbar } from 'notistack'

import './bootstrap';
import '@/i18n';


//import store from "./src/redux/store";

import { store } from "./src/redux/store";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const storePersistor = persistStore(store)
const container = document.getElementById('app')!;
const root = ReactDOMClient.createRoot(container);

{
    /* <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App/>
            </PersistGate>
        </Provider>
    */ 
}
root.render(
    <BrowserRouter basename={(process.env.APP_ALIAS ?? '/')}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={storePersistor}>

                <App />

            </PersistGate>
        </Provider>
    </BrowserRouter>
);
